"use strict";
import "stylesheets/comments.scss";
import "src/decidim/comments/comments";
import "src/decidim/comments/comments_mobile_modal";
